import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";

const Footer = () => (
  <footer className="bg-[#2B2B2B] text-white/75 pt-16 pb-8 font-manrope">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

        {/* Brand */}
        <div>
          <div className="font-playfair text-3xl text-white tracking-[0.25em] mb-1">LOOS</div>
          <div className="text-[10px] tracking-[0.3em] text-white/40 uppercase mb-5">Haltern am See</div>
          <p className="text-sm text-white/55 leading-relaxed">
            Vier Generationen, eine Familie, zwei Berufungen. Seit über 80 Jahren Ihr verlässlicher Partner in Haltern am See.
          </p>
        </div>

        {/* Schreinerei */}
        <div>
          <h4 className="text-[#C9A66B] uppercase tracking-[0.25em] text-xs mb-4">Schreinerei</h4>
          <div className="space-y-3 text-sm text-white/60">
            <div className="flex items-start gap-2.5">
              <MapPin size={13} className="mt-0.5 shrink-0 text-[#8B5E3C]" />
              <span>Lorenkamp 4<br />45721 Haltern am See</span>
            </div>
            <div className="flex items-center gap-2.5">
              <Phone size={13} className="shrink-0 text-[#8B5E3C]" />
              <a href="tel:023645042567" className="hover:text-white transition-colors">
                02364 / 5042567
              </a>
            </div>
          </div>
        </div>

        {/* Bestattungen */}
        <div>
          <h4 className="text-[#C9A66B] uppercase tracking-[0.25em] text-xs mb-4">Bestattungen</h4>
          <div className="space-y-3 text-sm text-white/60">
            <div className="flex items-start gap-2.5">
              <MapPin size={13} className="mt-0.5 shrink-0 text-[#3E4C59]" />
              <span>Mühlenstraße 6<br />45721 Haltern am See</span>
            </div>
            <div className="flex items-center gap-2.5">
              <Phone size={13} className="shrink-0 text-[#3E4C59]" />
              <a href="tel:023642384" className="hover:text-white transition-colors">
                02364 / 2384
              </a>
            </div>
            <div className="flex items-center gap-2.5 bg-[#3E4C59]/30 px-3 py-2 mt-2">
              <Clock size={13} className="shrink-0 text-[#C9A66B]" />
              <div>
                <div className="text-[10px] text-[#C9A66B] font-semibold uppercase tracking-widest leading-none mb-0.5">
                  24 / 7 Notfall
                </div>
                <a href="tel:+491714312224" className="text-white font-bold text-sm hover:text-[#C9A66B] transition-colors">
                  0171 / 4312224
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="text-[#C9A66B] uppercase tracking-[0.25em] text-xs mb-4">Navigation</h4>
          <nav className="flex flex-col gap-2.5 text-sm text-white/55">
            {[
              { to: "/", label: "Startseite" },
              { to: "/ueber-uns", label: "Über uns" },
              { to: "/schreinerei", label: "Schreinerei" },
              { to: "/bestattungen", label: "Bestattungen" },
              { to: "/kontakt", label: "Kontakt" },
            ].map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-white transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/35">
        <span>© {new Date().getFullYear()} Loos – Schreinerei & Bestattungen, Haltern am See</span>
        <div className="flex gap-5">
          <Link to="/impressum" className="hover:text-white/70 transition-colors" data-testid="footer-impressum">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-white/70 transition-colors" data-testid="footer-datenschutz">
            Datenschutz
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
